<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      :icon="
        !unreadNotifications.length && (notificationDenied || !paypingNotConnected)
          ? 'AlertCircleIcon'
          : 'BellIcon'
      "
      class="cursor-pointer mt-1 mr-2"
      :class="{ 'text-warning': notificationDenied || !paypingNotConnected }"
      :badge="unreadNotifications.length ? unreadNotifications.length : '' | persian_digits"
    />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ unreadNotifications.length | persian_digits }}</h3>
        <p class="opacity-75">{{ $t('notices.new_notices') }}</p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="ntf in unreadNotifications"
            :key="ntf.index"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
            @click="gotoSource(ntf)"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="ntf.icon ? ntf.icon : 'icon-alert-circle'"
                :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"
              ></feather-icon>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">
                  {{ ntf.title }}
                </span>
                <small>{{ ntf.description }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">
              {{
                $moment(ntf.created_at)
                  .locale('fa')
                  .fromNow() | persian_digits
              }}
              <div v-if="ntf.state === 'unseen'" class="text-right">
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                  @click="gotoSource(ntf)"
                />
              </div>
            </small>
          </li>
        </ul>
        <vs-alert color="warning" class="text-center" v-if="notificationDenied">
          <i class="fa fa-exclamation-triangle" />
          <span class="font-small">
            {{ $t('messages.push_notification_denied') }}
          </span>
        </vs-alert>
        <vs-alert color="warning" class="text-center" v-if="!paypingNotConnected">
          <i class="fa fa-exclamation-triangle" />
          <span class="font-small">
            {{ $t('messages.payping_not_connected_warn') }}
          </span>
        </vs-alert>
      </component>

      <div
        class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
      >
        <span @click="$router.push({ name: 'profile-notifications' })">{{ $t('notices.view_all') }}</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  methods: {
    seeNotification(notification) {
      this.$store.dispatch('notices/editNotice', { id: notification.id, data: { state: 'visited' } })
    },
    gotoSource(notice) {
      this.seeNotification(notice)
      if (notice.source) this.$router.push(notice.source)
    }
  },
  mounted() {
    this.$store.commit('notices/SET_NOTICES_QUERY', {
      to: this.$store.state.AppActiveUser.id,
      sort: { created_at: -1 }
    })
    this.$store.dispatch('notices/fetchNotices')
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    unreadNotifications() {
      return this.$store.getters['notices/unseen']
    },
    notificationDenied() {
      return 'Notification' in window && Notification.permission === 'denied'
    },
    paypingNotConnected() {
      return !(!this.$store.state.AppActiveUser.paypingOauthId && this.$acl.check('manager'))
    }
  }
}
</script>
